import React from 'react'

const RPMark = () => (
    <svg width="60" height="37" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M41.816 36.464 29.929 4.588.258 36.464h41.558Z" fill="#8D1B1C"/><path d="M59.018 36.465 52.818 0 .04 36.465h58.98Z" fill="#EE3030"/><path d="M33.304 13.636.26 36.466h41.553l-8.51-22.83Z" fill="#C62127"/></svg>
)

export default RPMark
